"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationIdProvider = exports.useLocationId = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_2 = require("react");
function useLocationId() {
    const { locationId: paramLocationId } = react_router_dom_1.useParams();
    const contextLocationId = react_1.useContext(Context);
    const locationId = paramLocationId !== null && paramLocationId !== void 0 ? paramLocationId : contextLocationId;
    if (!locationId) {
        throw new Error('Not able to identify the locationId.');
    }
    return locationId;
}
exports.useLocationId = useLocationId;
function LocationIdProvider({ children, locationId, }) {
    return jsx_runtime_1.jsx(Context.Provider, Object.assign({ value: locationId }, { children: children }), void 0);
}
exports.LocationIdProvider = LocationIdProvider;
const Context = react_2.createContext(null);
//# sourceMappingURL=useLocationId.js.map